import { createAsyncThunk } from "@reduxjs/toolkit";
import { showErrorStatus,} from "../../../security/state/user-slice";
import { specialistClientService } from "../../services/implementation-client-service";





export const getClients = createAsyncThunk(
  "implementationSpecialistClientContext/getClients",
  async (data: { includeFacility: boolean }, thunkAPI) => {
    const { includeFacility } = data
    const clients = await specialistClientService.getClients(includeFacility);
    // returned 'entity' contains objects for all clients, as well as clients filtered by closed, isActive, Stripe Set Up Incomplete, and more
    if (clients.hasErrors) {
      thunkAPI.dispatch(showErrorStatus(clients.errorMessage));
      throw new Error();
    } else {
      return clients.entity;
    }
  }
);











